export default {
    beneficiarioImportacaoEdition: {
        invalid: "Valor inválido",
        required: "Campo obrigatório",
        need_empresa: "É necessário preencher uma empresa válida",
        need_cpf_or_matricula: "É necessário informar o CPF ou a Matrícula do Beneficiários",
        temporarily_field_forbiden: "Campo proibido para preenchimento",
        only_options_valid: "Valores válidos: {options}",
        only_numbers: "Deve conter apenas números",
        only_10_11_numbers: "Deve conter apenas números e 10 ou 11 digitos",
        invalid_date: "O formato da data deve ser dd/mm/aaaa",
        depends_on_the_state: "Para preencher a cidade, é necessário preencher um Estado válido",
        more_than_one_company_for_code: "Existe mais de uma empresa no sistema com o id ou código informado: {options}",

        
        fieldScope: {
            unidade: {
                not_from_empresa: "A Unidade não pertence a empresa informada.",
                invalid: "Unidade inválida. Obs: a unídade deve estar relacionada com a empresa informada."
            },
            cidade: {
                invalid: "Valor inválido. Obs: certifique que não há acentos ou abreviações, e a cidade deve estar relacionada ao Estado."
            },
            email1: {
                invalid: "E-mail inválido"
            },
            email2: {
                invalid: "E-mail inválido"
            },
            cpfTitular: {
                not_in_system: "CPF do respectivo TITULAR não existe na base Optum. Verifique se o titular já foi importado com sucesso.",
                invalid: "CPF Titular inválido"
            },
            telefoneCelular : {
                only_10_11_numbers: "Por favor, digite um número válido."
            }
        }
    }
}